/* global _satellite */ // ESLint
import { logException } from './sentryService';
import { isAdobeSatelliteTrackingReady } from '../utils';

const adobeService = {
  trafficDataObjectJSON: '',
  addMessage(trafficDataMessage) {
    const type = trafficDataMessage.dataset.messageType;
    const key = trafficDataMessage.dataset.messageKey;

    this.trafficDataObjectJSON['traffic'].notifications.push({
      type,
      key,
    });
  },
  // Make the adobe call
  callTracking() {
    try {
      if (isAdobeSatelliteTrackingReady()) {
        _satellite.track('checkout');
      }
    } catch (e) {
      logException(e, { area: 'adobe', action: 'init adobeService' });
    }
  },
  init() {
    const trafficDataMessages = document.querySelectorAll(
      '[data-traffic-data-message="true"]'
    );
    const trafficDataObject = document.getElementById('trafficDataObject');

    if (!trafficDataMessages || !trafficDataObject) return;

    this.trafficDataObjectJSON = JSON.parse(
      trafficDataObject.innerText || '""'
    );

    [...trafficDataMessages].forEach((trafficDataMessage) =>
      this.addMessage(trafficDataMessage)
    );

    trafficDataObject.innerText = JSON.stringify(this.trafficDataObjectJSON);
    this.callTracking();
  },
};

export default adobeService;
